import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import { setupEntryPoint } from "./setupEntryPoint";
import { cartFormSetupEntryPoint } from "./cartFormEntryPoint";
import { useAuthStore } from "@/stores/auth";
import { useLineStore } from "@/stores/line";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// A LINE login is completed server-side, so the only thing it can hand the SPA
// is the shop-token cookie; without adopting it the visitor returns
// authenticated as far as Rails is concerned and logged out as far as this
// frontend is concerned.
//
// Registered as a plugin rather than calling useAuthStore(pinia) here: pinia
// defers plugins registered before app.use(pinia) (pinia.mjs:945-951) and
// applies them at store-creation time (:1573), so creating the store now would
// permanently exclude it from piniaPluginPersistedstate - silently losing
// logout, originalUrl and customerExisted across page loads. As a plugin this
// runs after hydration, whichever app creates the store first.
pinia.use(({ store }) => {
  if (store.$id === "auth") (store as ReturnType<typeof useAuthStore>).adoptSessionCookie();
});

const appEl = document.querySelector("#app");
const cartAppEL = document.querySelectorAll(
  "#lp-form, #confirm-form, #finish-form, #upsell-form, #cv-confirm-form, #cv-upsell-form, #cv-xsell-form, #next-offer-form",
);

// Not a pinia plugin like adoptSessionCookie above, because this store has to
// be created whether or not anything else asks for it: the Choose an Option
// screen issues no GraphQL at all, and if the token were not taken off `window`
// there it would be gone by the time the visitor reached the sign-in form.
//
// The position is load-bearing at both ends. It cannot move above
// app.use(pinia) - for the reason given above, the store would be created
// without piniaPluginPersistedstate and never reach sessionStorage. It cannot
// move below mount() either: onMounted hooks run synchronously inside mount(),
// and the LP's fires fetchLineLinkEmail() there (pages/lp/_url/index.vue), so
// the prefill query would go out before the token was in the store and come back
// with no email.
// Idempotent, so calling it once per app is fine: the second call finds
// `window.lineLinkToken` already removed and does nothing.
if (appEl) {
  const app = setupEntryPoint().use(pinia);
  useLineStore(pinia).adoptHandoffToken();
  app.mount("#app");
}

if (cartAppEL.length)
  cartAppEL.forEach((item) => {
    const app = cartFormSetupEntryPoint().use(pinia);
    useLineStore(pinia).adoptHandoffToken();
    app.mount(`#${item.id}`);
  });
